export const columnsDataComplex = [
  {
    Header: "SPEND",
    accessor: "spend",
  },
  {
    Header: "INSTALLS",
    accessor: "installs",
  },
  {
    Header: "CPI",
    accessor: "cpi",
  },
  {
    Header: "D0",
    accessor: "days.D0.retention",
  },
  {
    Header: "D1",
    accessor: "days.D1.retention",
  },
  {
    Header: "D3",
    accessor: "days.D3.retention",
  },
  {
    Header: "D7",
    accessor: "days.D7.retention",
  },
  {
    Header: "D14",
    accessor: "days.D14.retention",
  },
  {
    Header: "D30",
    accessor: "days.D30.retention",
  },
  {
    Header: "D60",
    accessor: "days.D60.retention",
  },
  {
    Header: "D90",
    accessor: "days.D90.retention",
  },
  {
    Header: "D120",
    accessor: "days.D120.retention",
  },
  {
    Header: "D150",
    accessor: "days.D150.retention",
  },
  {
    Header: "D180",
    accessor: "days.D180.retention",
  },
  {
    Header: "D365",
    accessor: "days.D365.retention",
  },
];
